var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:index == 0 ? 'sidebar_first' : ''},[_c('router-link',{class:_vm.currentPath == item.path && index > 0 ? 'cur' : '',attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }